import React from 'react';
import style from './Footer.module.scss';

function Footer() {
    return (
        <div className={style.footer}>
            <span className={style.text}>Copy Right 2023 © All Rights Reserved</span>
        </div>
    );
}

export default Footer;